<template>
    <div class="clearfix">
        <compFormEdit
            ref="form"
            :formdata="getBase"
            v-model="formData"
            :labelWidth="120"
            :col="1"
        ></compFormEdit>
        <compWrapper title="操作历史" theme="gray" v-if="type=='query'">
            <compLog :data="logList" ></compLog>
        </compWrapper>
        <div class="margin-15 pull-right">
            <Button class="margin-right-15" type="primary" @click="submit">{{
                $t("global.common.save", { defaultValue: "保存" })
            }}</Button>
            <Button type="default" @click="$emit('on-close')">{{
                $t("global.common.operation_cancel", { defaultValue: "取消" })
            }}</Button>
        </div>
        <Spin v-if="loading" fix></Spin>
    </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import {
    HttpGetBlackDetail,
    HttpUpdateBlackDetail,
} from "@/service/carrieraccount.js";
export default {
    props: ["activeid", "querytype"],
    data() {
        return {
            loading: false,
            formData: {},
            carrierGroupList: [],
            warehouseList: [],
            carrierServiceList: [],
            logList:[],
        };
    },
    created() {
        if (this.querytype !== "add") {
            this.getDetail();
        }
    },
    computed: {
        ...mapGetters("dictionary", [
            "getBillcusWareList",
        ]),
        getBase() {
            return [
                {
                    label: this.$t("global.common.warehouse", {
                        defaultValue: "仓库",
                    }),
                    key: "orgWarehouseId",
                    tag: "vSelect",
                    options: this.getBillcusWareList,
                    props: {
                        filterable: true,
                    },
                    required: true,
                },
                {
                    label: this.$t("erp.product_channel.type", {
                        defaultValue: "类型",
                    }),
                    key: "systemCarrierId",
                    tag: "vSelect",
                    options: [
                        {value:0,label:'快递'},
                        {value:1,label:'卡车'},
                    ],
                    props: {
                        filterable: true,
                    },
                    required: true,
                },
                {
                    label: this.$t("erp.b2c.shipping_method", {
                        defaultValue: "发货方式",
                    }),
                    key: "carrierGroupId",
                    tag: "vSelect",
                    options: this.carrierGroupList,
                },
                {
                    label:'限额',
                    key:'xiane',
                    tag:'vInput'
                },
            ];
        },
    },
    methods: {
        async getDetail() {
            this.loading = true;
            await HttpGetBlackDetail({
                id: this.activeid,
            }).then(
                (res) => {
                    this.formData = res.data;
                },
                (err) => {
                    this.$VMessage.error(err.message);
                }
            );
            this.loading = false;
        },
        async submit() {
            let flag = await this.$refs.form.validate();
            if (!flag) return;
            await HttpUpdateBlackDetail({
                id: this.activeid,
                ...this.formData,
            }).then(
                (res) => {
                    this.$VMessage.success(res.message);
                    this.$emit("on-update");
                    this.$emit("on-close");
                },
                (err) => {
                    this.$VMessage.error(err.message);
                }
            );
        },
    },
};
</script>

